import Header from "../../component/header";
import "../../styles/expiry.css";

export default function LinkExpired () {

    return (
        <div className="expiry-container">
            <Header />
            <div className="expiry-header-container">
                <div className="expiry-header">Sorry, you can't view this link at this time.</div>
                <div className="expiry-description">The link provided by the website has expired. Please contact us for further inquiries.</div>
            </div>
        </div>
    )
}